import { swiss } from '@theme-ui/presets';

const theme = {
  ...swiss,
  styles: {
    ...swiss.styles,
  },
  cards: {
    primary: {
      padding: 2,
      borderRadius: 4,
      boxShadow: '0 0 8px rgba(0, 0, 0, 0.125)',
    },
    compact: {
      padding: 1,
      borderRadius: 2,
      border: '1px solid',
      borderColor: 'muted',
    },
  },
  colors: {
    ...swiss.colors,
    primary: '#b25c48',
    secondary: '#b35a4a',
  },
};

export default theme;
